/**
 * web-studio-sites D13 — a link that moves through the page mover, in place of React Router's
 * `Link`. Its address is where the move lands, so a new tab opens where a click would go; a plain
 * click moves with the mover.
 */
import type { AnchorHTMLAttributes } from 'react';

import { useMoveHref, usePageMover } from '../pageMover';
import { onLink } from './onLink';

export type MoveLinkProps = { readonly to: string } & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'onClick'>;

export function MoveLink({ to, ...rest }: MoveLinkProps) {
  const move = usePageMover();
  return <a href={useMoveHref(to)} onClick={onLink(() => move(to))} {...rest} />;
}
